import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { AGENT_FIELD_FORM_LIMITS } from '../lib/constants';

export const useFormSchema = () => {
  const { t } = useTranslation('translation');

  const required = t('common.formErrors.required');

  const agentFieldSchema = z.object({
    name: z
      .string()
      .trim()
      .min(1, required)
      .max(
        AGENT_FIELD_FORM_LIMITS.name,
        t('common.formErrors.stringMaxLen', { max: AGENT_FIELD_FORM_LIMITS.name }),
      ),

    description: z
      .string()
      .trim()
      .max(
        AGENT_FIELD_FORM_LIMITS.description,
        t('common.formErrors.stringMaxLen', { max: AGENT_FIELD_FORM_LIMITS.description }),
      ),

    filter: z
      .array(
        z
          .string()
          .trim()
          .max(
            AGENT_FIELD_FORM_LIMITS.filter,
            t('common.formErrors.stringMaxLen', { max: AGENT_FIELD_FORM_LIMITS.filter }),
          ),
      )
      .min(1, t('common.formErrors.minNumber', { min: 1 }))
      .max(
        AGENT_FIELD_FORM_LIMITS.filterMax,
        t('common.formErrors.maxNumber', { max: AGENT_FIELD_FORM_LIMITS.filterMax }),
      ),

    alias: z.string().trim().max(128).optional().or(z.literal('')),

    useKnowledgeFilter: z.boolean(),

    isRequired: z.boolean(),

    isActive: z.boolean(),
  });

  return agentFieldSchema;
};
